var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white w-50 rounded-lg flex items-center pt-31 pl-31 pr-31 pb-31"},[_c('header',{staticClass:"w-full"},[_c('div',{staticClass:"title  "},[_vm._t("header")],2)]),_c('figure',{},[_vm._t("svg")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }